module.exports = __webpack_public_path__ + "static/L2_ux_3_1_eg-2ef32dc124d173a0163af08aeda4d773.png";